export const USER_SESSION_ID = 'X-User-Session-Id'
